//
import Model from "@/models/Model"

//
export default class WhWarehouseType extends Model {

    /**
     * 
     */
    resource() {
        return "wh_warehouse_type"
    }

    /**
     * 
     */
    toCreate () {
        return this.clean([
            "type"
        ])
    }
}